// Import model
import { CreateLeadRequest } from '../models/CreateLeadRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateLeadRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateLeadRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateLeadRequest instance
   */
  static deserialize(json: string): CreateLeadRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateLeadRequest instance
   */
  static fromObject(obj: any): CreateLeadRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateLeadRequest');
    }


    const instance: CreateLeadRequest = {
      fullName: obj['fullName'] as string,
      phone: obj['phone'] as string | undefined,
      email: obj['email'] as string | undefined,
      address: obj['address'] as string,
      city: obj['city'] as string,
      state: obj['state'] as string | undefined,
      postalCode: obj['postalCode'] as string | undefined,
      country: obj['country'] as string | undefined,
      userId: obj['userId'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      sfLeadSourceId: obj['sfLeadSourceId'] as string,
      leadTypeId: obj['leadTypeId'] as string | undefined,
      phonePreferences: obj['phonePreferences'] as string | undefined,
      smsPreferences: obj['smsPreferences'] as string | undefined,
      emailPreferences: obj['emailPreferences'] as string | undefined,
      flowId: obj['flowId'] as string | undefined,
      notes: obj['notes'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateLeadRequest instances
   */
  static deserializeArray(json: string): CreateLeadRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateLeadRequest instance to a JSON string
   */
  static serialize(instance: CreateLeadRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateLeadRequest instance to a plain object
   */
  static toObject(instance: CreateLeadRequest): any {
    return {
      'fullName': instance.fullName,
      'phone': instance.phone,
      'email': instance.email,
      'address': instance.address,
      'city': instance.city,
      'state': instance.state,
      'postalCode': instance.postalCode,
      'country': instance.country,
      'userId': instance.userId,
      'objectStatusId': instance.objectStatusId,
      'sfLeadSourceId': instance.sfLeadSourceId,
      'leadTypeId': instance.leadTypeId,
      'phonePreferences': instance.phonePreferences,
      'smsPreferences': instance.smsPreferences,
      'emailPreferences': instance.emailPreferences,
      'flowId': instance.flowId,
      'notes': instance.notes,
    };
  }

  /**
   * Serializes an array of CreateLeadRequest instances to a JSON string
   */
  static serializeArray(instances: CreateLeadRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
